import React from "react";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";
import ChargerStatus from "../../Charger/ChargerStatus";
import { BatteriesConnectedColumn, EnergySourceColumn } from "./Columns";
import PlugIcon from "../../../Common/Svgs/PlugIcon";
import ServiceIcon from "../../../Common/Svgs/ServiceIcon";
import ListDropdown from "./ListDropdown";

export const CSKpiData = (data) => {
  return [
    {
      id: 1,
      title: "Total No. Of Chargers",
      image: <ChargerIcon size={16} className="text-kpi-icon" />,
      count: data?.total || 0,
      redirect: false,
    },
    {
      id: 2,
      title: "No. Of Chargers Active",
      image: <PlugIcon size={16} className="text-kpi-icon" />,
      count: data?.active || 0,
      total: data?.total || 0,
      redirect: false,
    },
    {
      id: 3,
      title: "No. Of Chargers In Service",
      image: <ServiceIcon className="w-4 h-4 fill-none stroke-kpi-icon" />,
      count: data?.service || 0,
      redirect: true,
      icon: (
        <img
          src="/assets/icons/chevron-down.svg"
          className="-rotate-90 "
          alt="maintainance"
        />
      ),
    },
  ];
};

export const chargingStationColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Charger ID
      </div>
    ),
    dataIndex: "id",
    // width: "140px",
    sorter: (a, b) => a.id - b.id,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-black">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Status
      </div>
    ),
    dataIndex: "status",
    // width: "140px",
    sorter: (a, b) => a.status - b.status,
    render: (text) => <ChargerStatus status={text} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Energy Source
      </div>
    ),
    dataIndex: "id",
    width: "20%",
    render: (text, record) => <EnergySourceColumn record={record} />,
  },

  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray whitespace-nowrap">
        Batteries Connected
      </div>
    ),
    sorter: (a, b) => a.batteries - b.batteries,
    dataIndex: "batteries",
    render: (text, record) => <BatteriesConnectedColumn record={record} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Stored in Batteries
      </div>
    ),
    dataIndex: "batteryEnergy",
    sorter: (a, b) => a.batteryEnergy - b.batteryEnergy,
    // width: "200px",
    render: (text, record) => (
      <div>
        <div className="text-xs font-semibold font-aileron text-dark-gray capitalize whitespace-nowrap">
          {record?.batteries ? `${text} kWh` : "0.00 kWh"}
        </div>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Duration
      </div>
    ),
    dataIndex: "duration",
    // sorter: (a, b) => a.duration - b.duration,
    // width: "170px",
    render: (text, record) => (
      <div className="font-aileron text-dark-gray">
        <p className="text-xs font-semibold capitalize whitespace-nowrap">
          {record?.duration || "--"}
        </p>
        <p className="text-10 font-normal">Since 11:30 AM</p>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Operator
      </div>
    ),
    dataIndex: "operator",
    sorter: (a, b) => a.operator.localeCompare(b.operator),
    // width: "170px",
    render: (text) => (
      <div className="font-aileron font-semibold text-xs text-dark-gray">
        {text}
      </div>
    ),
  },
  {
    dataIndex: "id",
    width: "80px",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="w-full flex items-center justify-center invisible group-hover:visible"
      >
        <ListDropdown detail={record} />
      </button>
    ),
  },
];

export const chargingStationData = [
  {
    id: 1,
    status: 1,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: 4.56,
    duration: "15 Mins",
    operator: "Philipe",
  },
  {
    id: 2,
    status: 1,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: 4.56,
    duration: "30 Mins",
    operator: "Philipe",
  },
  {
    id: 3,
    status: 2,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: 4.56,
    duration: "15 Mins",
    operator: "Philipe",
  },
  {
    id: 4,
    status: 1,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 0,
    batteryEnergy: 0,
    duration: "15 Min",
    operator: "Philipe",
  },
  {
    id: 5,
    status: 2,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: "4.56",
    duration: "15 Min",
    operator: "Philipe",
  },
  {
    id: 6,
    status: 2,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 0,
    batteryEnergy: 4.56,
    duration: "1 Hr",
    operator: "Philipe",
  },
  {
    id: 7,
    status: 1,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: "4.56",
    duration: "2 Hrs",
    operator: "Philipe",
  },
  {
    id: 8,
    status: 1,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: "4.56",
    duration: "3 Hrs",
    operator: "Philipe",
  },
  {
    id: 9,
    status: 2,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: "4.56",
    duration: "15 Min",
    operator: "Philipe",
  },
  {
    id: 10,
    status: 2,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: "4.56",
    duration: "15 Min",
    operator: "Philipe",
  },
  {
    id: 11,
    status: 1,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: "4.56",
    duration: "15 Min",
    operator: "Philipe",
  },
  {
    id: 12,
    status: 2,
    storage: "60%",
    grid: "25%",
    solar: "15%",
    batteries: 3,
    batteryEnergy: "4.56",
    duration: "15 Min",
    operator: "Philipe",
  },
];

export const statusFilters = [
  {
    id: 1,
    value: <ChargerStatus status={1} />,
  },
  {
    id: 2,
    value: <ChargerStatus status={2} />,
  },
];

export const chargingHistoryColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Battery ID
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray py-1">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Range
      </div>
    ),
    dataIndex: "energyRange",
    sorter: (a, b) => a?.energyRange?.localeCompare(b?.energyRange),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Duration
      </div>
    ),
    dataIndex: "duration",
    sorter: (a, b) => a.duration - b.duration,
    render: (text) => {
      const formatDuration = () => {
        // if duration not present
        if (!text) return "--";

        const hrs = Math.floor(text / 60);
        const mins = text % 60;

        return `${hrs} H ${mins} M`;
      };

      return (
        <p className="font-aileron text-dark-gray text-xs font-semibold capitalize whitespace-nowrap">
          {formatDuration(text)}
        </p>
      );
    },
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Source
      </div>
    ),
    dataIndex: "id",
    render: (text, record) => {
      const getValue = () => {
        if (record.grid && record.storage) return "Grid + Storage";
        if (record.grid) return "Grid";
        if (record.storage) return "Storage";
        return "--";
      };

      return (
        <div className="font-aileron font-semibold text-xs text-dark-gray">
          {getValue()}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Time
      </div>
    ),
    dataIndex: "time",
    sorter: (a, b) => a?.time?.localeCompare(b?.time),
    render: (text) => (
      <div className="font-aileron font-semibold text-xs text-dark-gray">
        {text}
      </div>
    ),
  },
];

export const chargingHistoryData = [
  {
    id: 101,
    energyRange: "0.13-2.2kWh",
    duration: 320,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 102,
    energyRange: "0.13-2.2kWh",
    duration: 220,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 103,
    energyRange: "0.13-2.2kWh",
    duration: 200,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 104,
    energyRange: "0.13-2.2kWh",
    duration: 320,
    grid: true,
    storage: false,
    time: "08:45 PM",
  },
  {
    id: 105,
    energyRange: "0.13-2.2kWh",
    duration: 400,
    grid: false,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 106,
    energyRange: "0.13-2.2kWh",
    duration: 300,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 107,
    energyRange: "0.13-2.2kWh",
    duration: 320,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 108,
    energyRange: "0.13-2.2kWh",
    duration: 320,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 109,
    energyRange: "0.13-2.2kWh",
    duration: 320,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 110,
    energyRange: "0.13-2.2kWh",
    duration: 340,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 111,
    energyRange: "0.13-2.2kWh",
    duration: 340,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
  {
    id: 112,
    energyRange: "0.13-2.2kWh",
    duration: 340,
    grid: true,
    storage: true,
    time: "08:45 PM",
  },
];
